export default "__VITE_ASSET__BfyhO65L__"